import React from "react";
import {useSelector} from "react-redux";
import {RootState, useFetchIsOnlineQuery, useFetchUserConfigQuery} from "../../store";
import CreateFirstProvider from "../../pages/create-first-provider/CreateFirstProvider";
import Login from "../../pages/login/Login";
import {Alert, CircularProgress} from "@mui/material";
import {LoadingItem} from "../loading-item/LoadingItem";
import {useTranslation} from "react-i18next";

interface RedirectorProps {
    children: React.ReactNode;
}

const Redirector = ({children}: RedirectorProps) => {
    const {t} = useTranslation();
    const isLoading = useSelector((state: RootState) => state.loader.isLoading);
    const isLoggedIn = useSelector((state: RootState) => state.auth.isLoggedIn);
    const {data: isOnline} = useFetchIsOnlineQuery();
    const {
        data: userConfig,
        error,
        isFetching: isUserConfigFetching,
        refetch
    } = useFetchUserConfigQuery(undefined, {
        skip: !isLoggedIn || !isOnline
    });

    const onSubmit = () => {
        refetch();
    }

    const isComponentLoading = () => {
        return (userConfig === undefined && !error) || isLoading || isUserConfigFetching;
    }

    if (!isOnline && !isLoading) {
        return <Alert severity="error">{t("Service is OFFLINE! We should come back after a few minutes.")}</Alert>;
    }

    if (isOnline && !isLoggedIn) {
        return <Login/>;
    }

    if (isComponentLoading()) {
        return <LoadingItem><CircularProgress/></LoadingItem>;
    }

    if (!userConfig) {
        return <Alert severity="error">{t("No user config found!")}</Alert>;
    }

    if (error || userConfig.experience == 0) {
        return <CreateFirstProvider onSubmit={onSubmit}/>;
    }

    // if (userProgress.experience == 1) {
    //     return <CreateFirstRevenue onSubmit={onSubmit}/>;
    // }


    return <>{children}</>;
};

export default Redirector;